module.exports = __webpack_public_path__ + "assets/img/icon-pawben.ffb42399.png";